"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.apiVoucherCredit_post = exports.api_voucher_credit_post_failure = exports.api_voucher_credit_post_success = exports.api_voucher_credit_post_request = exports.API_VOUCHER_CREDIT_POST_FAILURE = exports.API_VOUCHER_CREDIT_POST_SUCCESS = exports.API_VOUCHER_CREDIT_POST_REQUEST = undefined;

var _index = require("axios/index");

var _index2 = _interopRequireDefault(_index);

var _nodeToolbox = require("@esnpm/node-toolbox");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_VOUCHER_CREDIT_POST_REQUEST = exports.API_VOUCHER_CREDIT_POST_REQUEST = "API_VOUCHER_CREDIT_POST_REQUEST";
var API_VOUCHER_CREDIT_POST_SUCCESS = exports.API_VOUCHER_CREDIT_POST_SUCCESS = "API_VOUCHER_CREDIT_POST_SUCCESS";
var API_VOUCHER_CREDIT_POST_FAILURE = exports.API_VOUCHER_CREDIT_POST_FAILURE = "API_VOUCHER_CREDIT_POST_FAILURE";

var api_voucher_credit_post_request = exports.api_voucher_credit_post_request = function api_voucher_credit_post_request(options) {
	return {
		type: API_VOUCHER_CREDIT_POST_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

var api_voucher_credit_post_success = exports.api_voucher_credit_post_success = function api_voucher_credit_post_success(data) {
	return {
		type: API_VOUCHER_CREDIT_POST_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

var api_voucher_credit_post_failure = exports.api_voucher_credit_post_failure = function api_voucher_credit_post_failure(error) {
	return {
		type: API_VOUCHER_CREDIT_POST_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Voucher.apiVoucherCredit_post
	Bucht CREDIT auf Voucher und setzt ihn auf ASSIGNED
	        :param HASH: str Identifier
	        :param CREDIT: float Betrag, welcher verbucht werden soll
	        :param DRY_RUN: bool Wenn False werden daten weggeschrieben
	        :exception: PropertyNotSetException Wenn HASH nicht gesetzt wurde
	        :exception: VoucherNotFoundException Wenn es den Voucher nicht gibt
	        :exception: VoucherCreditMinimumToLow Wenn Credit zu klein war
	        :exception: VoucherCreditMaximumToLarge Wenn Credit zu gross war
	        :return: dict Voucher
*/
var apiVoucherCredit_post = exports.apiVoucherCredit_post = function apiVoucherCredit_post(options) {
	return (
		// eslint-disable-next-line no-unused-vars
		function (dispatch, getState) {
			return new _bluebird2.default(
			// eslint-disable-next-line no-unused-vars
			function (resolve, reject) {
				dispatch(api_voucher_credit_post_request(options));
				var url = (0, _nodeToolbox.getAPIUrl)([{ "parameters": ["HASH"], "url": "/api/voucher/${options.HASH}/credit" }], options);
				(0, _index2.default)({
					method: "post",
					url: url,
					data: {
						CREDIT: options.CREDIT,
						DRY_RUN: options.DRY_RUN
					}
				}).then(function (response) {
					if (response.data.SUCCESSFUL) {
						dispatch(api_voucher_credit_post_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_voucher_credit_post_failure(response.data));
						resolve();
					}
				}, function (err) {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				});
			});
		}
	);
};